'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

var _reactRedux = require('react-redux');

var _events = require('redux/modules/events');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatchSetMapView: function dispatchSetMapView(mapView) {
      dispatch((0, _events.setMapView)(mapView));
    }
  };
};

var ViewToggleContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    location: state.router.location,
    mapView: state.events.mapView
  };
}, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ViewToggleContainer, _Component);

  function ViewToggleContainer() {
    (0, _classCallCheck3.default)(this, ViewToggleContainer);
    return (0, _possibleConstructorReturn3.default)(this, (ViewToggleContainer.__proto__ || (0, _getPrototypeOf2.default)(ViewToggleContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ViewToggleContainer, [{
    key: 'handleSetMapView',
    value: function handleSetMapView(mapView) {
      this.props.dispatchSetMapView(mapView);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var properties = {
        mapView: this.props.mapView,
        handleSetMapView: function handleSetMapView() {
          _this2.handleSetMapView(!_this2.props.mapView);
        }
      };
      return this.props.children(properties);
    }
  }]);
  return ViewToggleContainer;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.func,
  location: _react.PropTypes.object,
  mapView: _react.PropTypes.bool.isRequired,
  dispatchSetMapView: _react.PropTypes.func.isRequired
}, _class2.defaultProps = {
  children: function children(_ref) {
    var mapView = _ref.mapView,
        handleSetMapView = _ref.handleSetMapView;

    return _react2.default.createElement(
      _caligramReact.Tabs,
      { small: true, selected: mapView ? 'map' : 'list' },
      _react2.default.createElement(_caligramReact.Tab, { key: 'list', title: 'Liste', icon: 'list', action: function action() {
          return handleSetMapView(false);
        } }),
      _react2.default.createElement(_caligramReact.Tab, { key: 'map', title: 'Carte', icon: 'location', action: function action() {
          return handleSetMapView(true);
        } })
    );
  }
}, _temp)) || _class);
exports.default = ViewToggleContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ViewToggleContainer.js
// module id = 1191
// module chunks = 0